import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { faEdit, faImage, faCheck, faFileDownload, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

//Helpers
import { showMessage, showQuestion } from '../../../helpers/message';
import downloadBase64File from '../../../helpers/downloadFile';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//API
import agenda_api from '../../../api/agenda_api';

//Context
import { useAuth } from '../../../context/auth';

//Components
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField';
import requerimento_api from '../../../api/requerimento';

export default function AcoesRealizadas({ showDivs, requerimento, editavel, loadRequerimento }) {
    //Estado para loading
    const { setLoading, session } = useAuth();

    //Estado de controle da imagem a ser exibida no modal de imagens do formulario
    const [imagemFormulario, setImagemFormulario] = useState(null);

    //Estado de controle da edição do agendamento
    const [agendamento, setAgendamento] = useState({
        id: "",
        dataAgendamento: ""
    });

    //Estado de controle de visibilidade do modal de agendamento
    const [visibleModalEdicaoAgendamento, setVisibleModalEdicaoAgendamento] = useState(false);

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState(false);

    //Função para baixa arquivo
    function handleDownloadFile(fileData, fileName) {
        downloadBase64File(fileData, fileName);
    }

    //Função que inicializa o id do agendamento para edição
    const editarAgendamento = (id) => {
        setAgendamento({
            ...agendamento,
            id: id
        });
        toggleModalEdicaoAgendamento();
    }

    //Controle de visibilidade do modal de edição do agendamento
    const toggleModalEdicaoAgendamento = () => {
        setVisibleModalEdicaoAgendamento(!visibleModalEdicaoAgendamento);
        if (visibleModalEdicaoAgendamento) {
            setErrors(false);
            setAgendamento({
                id: "",
                dataAgendamento: ""
            })
        }
    }

    //função de onchange do agendamento a ser editado
    const onChangeAgendamento = (e) => {
        const { name, value } = e.target;
        setAgendamento({
            ...agendamento,
            [name]: value
        })
    }
    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    const onClickTimeLine = (index) => {
        setShowContent({
            ...showContent,
            [index]: !showContent[index]
        })
    }

    //Função de envio de edição do agendamento
    const atualizarAgendamento = () => {
        const _errors = validarCampos(agendamento, [objCampo({ name: "dataAgendamento", required: true })]);

        if (new Date(agendamento.dataAgendamento) < new Date(moment().format("YYYY-MM-DD"))) {
            _errors[0].dataAgendamento = { message: "" };
            _errors[1].push(objCampo({ name: "dataAgendamento", required: true }));
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        setLoading(true);
        agenda_api.put(agendamento).then(response => {
            showMessage("Sucesso", "Agendamento atualizado com sucesso!", "success", null);
            toggleModalEdicaoAgendamento();
            loadRequerimento();
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    };

    //Função de cancelamento da remoção de alguma arvore do requerimento
    const handleMudarSituacaoArvore = (situacao, id) => {
        setLoading(true);
        requerimento_api.MudarSituacaoEspecie({
            requerimentoEspecie_Id: id,
            situacao: situacao
        }).then(response => {
            loadRequerimento();
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        const _showContent = {};
        requerimento.requerimentoAcos.map((value, index) => {
            if (index == 0) {
                _showContent[index] = true;
            } else {
                _showContent[index] = showDivs;
            }
        })
        setShowContent(_showContent);
    }, [showDivs]);
    return (
        <>
            <ModalCustomized className={"modalMenor"} title={"Agendar fiscalização"} isOpen={visibleModalEdicaoAgendamento} toggle={toggleModalEdicaoAgendamento} btnClose={true}>
                <div className='row'>
                    <div className='col-md-12'>
                        <TextField name={"dataAgendamento"} type={"date"} label={"Data do agendamento"} value={agendamento.dataAgendamento} onChange={onChangeAgendamento} invalid={errors != false && !!errors.dataAgendamento} />
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                    <Button color='warning text-white' onClick={atualizarAgendamento}><FontAwesomeIcon icon={faEdit} /> Editar</Button>
                </div>
            </ModalCustomized>
            <ModalCustomized className={"modalMenor"} title={"Imagem"} isOpen={imagemFormulario != null} toggle={() => setImagemFormulario(null)} btnClose={true}>
                <div className='w-100 d-flex align-items-center justify-content-center'>
                    {imagemFormulario != null &&
                        <img className='rounded-3' src={imagemFormulario} width={200} />
                    }
                </div>
            </ModalCustomized >
            {requerimento?.requerimentoAcos?.length > 0 && requerimento.requerimentoAcos.map((value, index) => (
                <div className=' px-2 contentGroup' style={{ position: "relative" }} key={index}>
                    <div className='text-white pointHistory d-lg-flex d-md-none'>
                        <FontAwesomeIcon size='xs' icon={faCheck} />
                    </div>
                    <div className='row shadowFicha rounded-1 mt-2 mb-4'>
                        <h6 role='button' onClick={() => onClickTimeLine(index)} className={`m-0 py-2 titleFicha ${showContent[index] ? "mb-2" : "close"} d-flex align-items-center justify-content-between`}>
                            <span>
                                <span className="me-2">{moment(value?.dataHora).format("DD/MM/YYYY HH:mm:ss")}</span> - <span className='ms-2 resultFicha'>{value.identificacaoEtapa}</span>
                            </span>
                            <span>
                                <FontAwesomeIcon icon={showContent[index] ? faAngleUp : faAngleDown} />
                            </span>
                        </h6>
                        <div className={`cardContainer ${showContent[index] ? "" : "close"}`}>
                            {value?.nomeUsuario &&
                                <div className='mb-2 col-md-12 col-lg-6'>
                                    <span>
                                        <span className="fw-bold">Usuário: </span> {value?.nomeUsuario}
                                    </span>
                                </div>
                            }
                            {value.agendamento &&
                                <>
                                    <div className='row'>
                                        <div className='mb-2 col-md-12 col-lg-12'>
                                            <span>
                                                <span className="fw-bold">Data do agendamento: </span> {moment(value.agendamento.dataAgendamento).format("DD/MM/YYYY")}
                                                {value.agendamento.agendamentoDoRequerimento.status == "Agendado" && editavel && requerimento.situacao == "Em Andamento" && (session.perfil == "Gestor" || session.perfil == "Master") &&
                                                    <Button className='ms-4' color='warning text-white' onClick={() => editarAgendamento(value.agendamento.id)}>
                                                        <FontAwesomeIcon icon={faEdit} /> Editar
                                                    </Button>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className='mb-2 col-md-12 col-lg-12'>
                                <span>
                                    <span className="fw-bold">Resposta: </span> {value?.acaoRealizada}
                                </span>
                            </div>
                            {value.observacoes &&
                                <div md="12" lg="12" className='mb-2 col-md-12 col-lg-12'>
                                    <span>
                                        <span className="fw-bold">Observações: </span> {value?.observacoes}
                                    </span>
                                </div>
                            }
                            {
                                value.documentos != null && value.documentos.length > 0 &&
                                <div className='px-3 py-2'>
                                    <div className='py-2 d-flex align-items-start justify-content-center gap-3 flex-wrap'>
                                        {value.documentos.map((value, index) => (
                                            <Button
                                                key={index}
                                                outline
                                                color='secondary'
                                                onClick={() => handleDownloadFile(value.base64, value.identificacaoDocumento)}
                                            >
                                                <FontAwesomeIcon icon={faFileDownload} />
                                                <span className="ms-2">{value.identificacaoDocumento}</span>
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            }
                            {
                                value.formularios && value.formularios.length > 0 &&
                                value.formularios.map((formulario, index) => {
                                    return (
                                        <div className='row' key={index}>
                                            <div className='mb-2 col-md-12 col-lg-12'>
                                                <h5 className='d-flex align-items-center justify-content-between'>
                                                    {formulario.nomeFormulario}
                                                    {!!formulario.requerimentoEspecie && !formulario.requerimentoEspecie.excluido && requerimento.situacao == "Em Andamento" && (session.perfil == "Gestor" || session.perfil == "Master") &&
                                                        <TextField
                                                            label={"Situação"}
                                                            type={"select"}
                                                            options={[
                                                                { value: "Pendente", label: "Pendente" },
                                                                { value: "Poda", label: "Poda" },
                                                                { value: "Excluído", label: "Excluído" },
                                                                { value: "Supressão Deferida", label: "Supressão Deferida" },
                                                                { value: "Supressão Indeferida", label: "Supressão Indeferida" },
                                                                { value: "Supressão Indevida", label: "Supressão Indevida" },
                                                            ]}
                                                            name="situacao"
                                                            onChange={(e) => {
                                                                handleMudarSituacaoArvore(e.target.value, formulario.requerimentoEspecie.id);
                                                            }}
                                                            value={formulario.requerimentoEspecie.situacao}
                                                            disabled={!value.indicarSituacao}
                                                        />
                                                    }
                                                </h5>
                                            </div>
                                            {
                                                !!formulario.requerimentoEspecie &&
                                                <div className='mb-2 col-md-12 col-lg-12'>
                                                    <p>
                                                        <span><span className="fw-bold">Espécie:</span> {formulario.requerimentoEspecie.especie}</span>
                                                        <Button outline className='ms-3 px-2 py-0' color='secondary' onClick={() => {
                                                            setImagemFormulario(formulario.requerimentoEspecie.imagem)
                                                        }}><FontAwesomeIcon size='xs' icon={faImage} /></Button>
                                                    </p>
                                                </div>
                                            }
                                            {
                                                formulario.requerimentoAcaoFormularioResposta.map((resposta, index) => {
                                                    return (
                                                        <div className='col-md-12 col-lg-12' key={index}>
                                                            <p>
                                                                <span className="fw-bold">{resposta.questao}</span> {resposta.valor}
                                                                {resposta.imagem &&
                                                                    <Button outline className='ms-3 px-2 py-0' color='secondary ' onClick={() => {
                                                                        setImagemFormulario(resposta.imagem);
                                                                    }}><FontAwesomeIcon size='xs' icon={faImage} /></Button>
                                                                }
                                                            </p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>
                </div>
            ))
            }
        </>
    )
}